import { type Command } from '@telespot/core';

/**
 * @group Protocols
 * @category Payloads
 */
export interface UpdateAlgorithmMetadataDetails {
  /**
   * The id of the algorithm to update.
   */
  algorithmId: string;

  /**
   * Optional new name for the algorithm.
   */
  name?: string;

  /**
   * Optional new description for the algorithm.
   */
  description?: string;

  /**
   * Optional new version for the algorithm.
   */
  version?: string;

  /**
   * Optional new regulated status for the algorithm.
   */
  regulated?: boolean;
}

/**
 * @group Protocols
 * @category Tokens
 */
export const UPDATE_ALGORITHM_METADATA = 'protocols:updateAlgorithmMetadata';

export class UpdateAlgorithmMetadata
  implements Command<typeof UPDATE_ALGORITHM_METADATA, UpdateAlgorithmMetadataDetails>
{
  public readonly name = UPDATE_ALGORITHM_METADATA;
  constructor(public readonly details: UpdateAlgorithmMetadataDetails) {}
}
